import { useQuery, useMutation, useQueryClient } from "react-query";
import { trackEventsApi } from "../services/api";

export const useTrackEvents = (
  filters: { page?: number; page_size?: number; search?: string } = {},
) => {
  return useQuery(
    ["track-events", filters],
    () => trackEventsApi.list(filters),
    { keepPreviousData: true },
  );
};

export const useScriptTrackEvents = (scriptId: number) => {
  return useQuery(
    ["script-track-events", scriptId],
    () => trackEventsApi.getForScript(scriptId),
    { enabled: !!scriptId },
  );
};

export const useUpdateScriptTrackEvents = (scriptId: number) => {
  const qc = useQueryClient();
  return useMutation(
    (trackEventIds: number[]) =>
      trackEventsApi.setForScript(scriptId, trackEventIds),
    {
      onSuccess: () => {
        qc.invalidateQueries(["script-track-events", scriptId]);
      },
    },
  );
};
